import { FC } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const Error404: FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10'>
        {/* begin::Illustration */}
        <img
          // src={toAbsoluteUrl('/media/illustrations/sketchy-1/18_dark.svg')}
          alt=''
          className='mw-100 h-lg-400px logo404 mb-4'
        />
        {/* end::Illustration */}
        {/* begin::Message */}
        <h1 className='fw-bold mb-5' style={{ color: '#A3A3C7' }}>
          ops! página no encontrada.
        </h1>
        {/* end::Message */}
        {/* begin::Link */}
        <Link to='/' className='btn btn-primary MoradoOscuro'>
          Volver al Inicio
        </Link>
        {/* end::Link */}
      </div>
    </div>
  )
}

export { Error404 }
